import request from '@/utils/request';

function apiSaveMappings(mappings) {
  return request({
    data: mappings,
    method: 'put',
    url: '/defaultbottomfinishmapping/saveMappings'
  });
}

function apiReadMappings() {
  return request({
    method: 'get',
    url: '/defaultbottomfinishmapping/readMappings'
  });
}

function apiReadWebAtelierFinishes() {
  return request({
    method: 'get',
    url: '/defaultbottomfinishmapping/readWebAtelierFinishes'
  });
}

export const storeExtensions = {
  actions: {
    saveMappings({ commit }, mappings) {
      return apiSaveMappings(mappings);
    },
    readMappings({ dispatch }) {
      return apiReadMappings();
    },
    readWebAtelierFinishes({ dispatch }) {
      return apiReadWebAtelierFinishes();
    }
  }
};
